import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { AxnAttributeLabel } from "@idw-types/data/reference-data/axn";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";

type CreateAxnAttributeLabelRequestResponse = {
    response: AxnAttributeLabel;
};

export const createAxnAttributeLabelRequest = async (
    axnAttributeLabel: AxnAttributeLabel
): Promise<GenericNetworkResponse<CreateAxnAttributeLabelRequestResponse>> => {
    const route = apiRoutes.axnadminCore.data.axnattributelabel;

    const body: Partial<AxnAttributeLabel> = {
        attributeTypeID: axnAttributeLabel.attributeTypeID,
        label: axnAttributeLabel.label
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};